<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="user-page">
    <el-container>
      <el-header>
        <div class="header">
          <div class="left">
            <div class="back-btn" @click="goBack">
              <el-icon :size="20"><ArrowLeft /></el-icon>
              <span class="back-text">返回</span>
            </div>
            <span class="title">个人中心</span>
          </div>
          <template v-if="isLogin">
            <div class="user-info">
              <div class="user-avatar">
                <el-image
                  :src="userInfo.avatar"
                  :preview-src-list="[userInfo.avatar]"
                  fit="cover"
                />
              </div>
              <div class="user-nickname">{{ userInfo.nickname }}</div>
              <div class="user-sex">{{ sexOptions[userInfo.sex] }}</div>
              <div v-if="userInfo.brithDay" class="user-birthday">
                {{ calcTime(userInfo.brithDay, 'y-M-d') }}
              </div>
              <el-button size="large" round @click="logoutClickHandle">退出登录</el-button>
            </div>
          </template>
          <template v-else>
            <el-button
              size="large"
              round
              type="primary"
              color="#026ccb"
              @click="() => (loginDialogShow = true)"
            >
              立即登录
            </el-button>
          </template>
        </div>
      </el-header>
      <el-container>
        <el-aside><user-menu v-if="isLogin" @select="menuSelectHandle" /></el-aside>
        <el-main class="main-content">
          <template v-if="mainComponent && isLogin">
            <component :is="mainComponent" v-bind="componentProps" />
          </template>
        </el-main>
      </el-container>
    </el-container>

    <LoginDialog v-model:show="loginDialogShow" :detail-id="0" @loginSuccess="loginSuccessHandle" />
  </div>
</template>

<script setup>
  import { ref, unref, computed, onActivated } from 'vue'
  import { useRouter } from 'vue-router'
  import { ElMessageBox } from 'element-plus'
  import { getAccountInfo } from '@/api/user'
  import LoginDialog from './LoginDialog.vue'
  import UserMenu from '@/components/UserMenu.vue'
  import OrderList from '@/components/OrderList.vue'
  import { menuTypeEnum } from '@/enums/menuEnum'
  import { calcTime } from '@/utils'

  const router = useRouter()

  const sexOptions = ['女', '男']
  const userInfo = ref({})
  const isLogin = computed(() => unref(userInfo)?.id)
  const loginDialogShow = ref(false)
  const loginSuccessHandle = () => {
    loginDialogShow.value = false
    getInitData()
  }
  const logoutClickHandle = () => {
    ElMessageBox.confirm('是否退出登录？')
      .then(() => {
        localStorage.clear()
        userInfo.value = {}
      })
      .catch(() => {})
  }

  const orderStatuses = ref('')
  const menuType = ref(menuTypeEnum.orderList)
  const mainComponent = computed(() => {
    switch (unref(menuType)) {
      case menuTypeEnum.orderList:
        return OrderList
    }
    return null
  })
  const componentProps = computed(() => {
    switch (unref(menuType)) {
      case menuTypeEnum.orderList:
        return {
          statuses: unref(orderStatuses) ? [unref(orderStatuses)] : []
        }
    }
    return {}
  })
  const menuSelectHandle = data => {
    menuType.value = data.menuType
    switch (unref(menuType)) {
      case menuTypeEnum.orderList:
        data.type !== unref(orderStatuses) && (orderStatuses.value = data.type)
        break
    }
  }

  const getInitData = () => {
    getAccountInfo()
      .then(res => res && (userInfo.value = res))
      .catch(console.log)
  }

  const goBack = () => {
    router.back()
  }

  onActivated(getInitData)
</script>

<style scoped lang="scss">
  // 变量定义
  $primary-color: #ff0000;
  $secondary-color: #ff6b6b;
  $text-color: #333;
  $text-light: #666;
  $bg-color: #f9f9f9;
  $bg-light: #f5f7fa;
  $bg-lighter: #f8f8f8;
  $border-color: #ddd;
  $shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .user-page {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: $bg-color;
    padding: 10px 40px;
    position: relative;

    :deep(.el-container) {
      flex: 1;
      gap: 20px 40px;

      .el-aside,
      .el-main {
        padding: 20px;
        border-radius: 12px;
        background-color: #fff;
      }
    }

    :deep(.el-menu) {
      border-right: none;
    }

    :deep(.el-container) {
      overflow: hidden;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    margin: 0 -20px;

    .left {
      display: flex;
      align-items: center;

      .back-btn {
        display: flex;
        align-items: center;
      }

      .back-text {
        font-size: 16px;
        color: $text-color;
        cursor: pointer;
      }

      .title {
        margin-left: 40px;
        font-size: 16px;
        font-weight: bold;
      }
    }

    .user-info {
      display: flex;
      align-items: center;
      gap: 12px;

      .user-avatar {
        width: 50px;
        height: 50px;
      }
    }
  }

  .main-content {
    display: flex;
    flex-direction: column;
    background-color: transparent !important;
  }
</style>
